import * as zhTW from '../../../../../../config/locales/js/zh-TW.json';
angular.module('cerego.translate').constant('translateZhTW', zhTW);
